import { createStore } from "vuex";
import router from "../router";

export default createStore({
  state: {
    survey: {
      shop: {
        name: "",
        phone: "",
        address: "",
        economic: "",
        meterage: "",
        locshop: "",
        sizeshop: "",
        location: {
          latitude: "",
          longitude: "",
        },
        locationError: "",
        province: "",
        city: "",
        mobile: "",
      },
      productSurvey: {
        hasProducts: "",
        productNotPresentReason: "",
      },
      competitorAnalyze: [],
      tabarokQuestion: [],
      detail: {
        description: "",
      },
      datetime: "",
    },
    province: localStorage.getItem("province") || "",
    city: localStorage.getItem("city") || "",
    mobile: localStorage.getItem("mobile") || "",
  },
  mutations: {
    SET_SHOP_INFO(state, shop) {
      state.survey.shop = shop;
    },
    SET_PRODUCT_SURVEY(state, productSurvey) {
      state.survey.productSurvey = productSurvey;
    },
    SET_TABAROK_QUESTION(state, tabarokQuestion) {
      console.log(tabarokQuestion)
      state.survey.tabarokQuestion = tabarokQuestion;
    },
    SET_COMPETITOR_ANALYZE(state, competitorAnalyze) {
      state.survey.competitorAnalyze = competitorAnalyze;
    },
    SET_DETAIL(state, detail) {
      state.survey.detail = detail;
      this.commit("PERSIST_TO_LOCAL_STORAGE");
    },
    SET_CITY(state, { province, city, mobile }) {
      state.province = province;
      state.city = city;
      state.mobile = mobile;
      localStorage.setItem("province", province);
      localStorage.setItem("city", city);
      localStorage.setItem("mobile", mobile);
    },
    PERSIST_TO_LOCAL_STORAGE(state) {
      let datetime = new Date().toLocaleDateString("fa-IR");
      datetime = datetime.replace(/([۰-۹])/g, (token) =>
        String.fromCharCode(token.charCodeAt(0) - 1728)
      );
      datetime += " " + new Date().getHours() + ":" + new Date().getMinutes();
      state.survey.datetime = datetime;
      state.survey.shop.province = state.province;
      state.survey.shop.city = state.city;
      state.survey.shop.mobile = state.mobile;

      let surveys = localStorage.getItem("surveys")
        ? JSON.parse(localStorage.getItem("surveys"))
        : [];

      if (state.survey.editIndex !== undefined) {
        surveys[state.survey.editIndex] = state.survey;
      } else {
        surveys.push(state.survey);
      }
      localStorage.setItem("surveys", JSON.stringify(surveys));

      state.survey = {
        shop: {
          name: "",
          phone: "",
          address: "",
          type: "",
          sub_type: "",
          location: {
            latitude: "",
            longitude: "",
          },
          locationError: "",
          province: "",
          city: "",
          mobile: "",
        },
        productSurvey: {
          hasProducts: "",
          productNotPresentReason: "",
        },
        competitorAnalyze: [],
        detail: {
          description: "",
        },
        datetime: "",
      };

      router.push("/history");
    },
    EDIT_SURVEY(state, survey) {
      console.log(survey)
      state.survey = survey;
    },
    EMPTY_SURVEYS() {
      localStorage.removeItem("surveys");
    },
  },
  actions: {
    setShopInfo({ commit }, shop) {
      commit("SET_SHOP_INFO", shop);
    },
    setProductSurvey({ commit }, productSurvey) {
      commit("SET_PRODUCT_SURVEY", productSurvey);
    },
    setTabarokQuestions({ commit }, tabarokQuestion) {
      commit("SET_TABAROK_QUESTION", tabarokQuestion);
    },
    setCompetitorAnalyze({ commit }, competitorAnalyze) {
      commit("SET_COMPETITOR_ANALYZE", competitorAnalyze);
    },
    setDetail({ commit }, detail) {
      commit("SET_DETAIL", detail);
    },
    setCity({ commit }, { city, province, mobile }) {
      commit("SET_CITY", { city, province, mobile });
    },
    editSurvey({ commit }, survey) {
      commit("EDIT_SURVEY", survey);
    },
    emptySurveys({ commit }) {
      commit("EMPTY_SURVEYS");
    },
  },
  modules: {},
});
